module.exports = __webpack_public_path__ + "static/media/Screen Shot 2023-02-20 at 14.27.32@2x.02c17425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screen Shot 2023-02-20 at 14.27.32@2x.png
// module id = 571
// module chunks = 1